import { useState, useRef, useEffect, useCallback, Suspense } from 'react'
import { Outlet, useLocation } from 'react-router'
// import { useTranslation } from 'react-i18next'
import { getTheme, ToastContainer } from '@totalsoft/rocket-ui'

import { env } from 'utils/env'
import { Content } from './AppStyle'

import Sidebar from './layout/sidebar/Sidebar'
import Header from './layout/header/Header'
import Footer from './layout/footer/Footer'
import { liteMode } from 'features/chat/functions'

const isWeb = () => window.matchMedia(`(min-width: ${getTheme().breakpoints.values.md})`)?.matches

// Webchat
const displaySidebar = JSON.parse(env.REACT_APP_WEBCHAT_DISPLAY_SIDEBAR) && !(JSON.parse(env.REACT_APP_WEBCHAT_IS_ANONYMOUS) || liteMode())
const displayHeader = JSON.parse(env.REACT_APP_WEBCHAT_DISPLAY_OUTER_HEADER)

export default function App() {
  const location = useLocation()
  const mainPanelRef = useRef()

  useEffect(() => {
    document.title = env.REACT_APP_TITLE
  })

  const [drawerOpen, setDrawerOpen] = useState(isWeb())
  window.onresize = _e => setDrawerOpen(isWeb())

  const handleDrawerToggle = useCallback(() => {
    setDrawerOpen(!drawerOpen)
  }, [drawerOpen])

  const handleCloseDrawer = useCallback(() => {
    if (!drawerOpen) return
    setDrawerOpen(false)
  }, [drawerOpen])

  useEffect(() => {
    if (mainPanelRef?.current?.scrollTop) mainPanelRef.current.scrollTop = 0
  }, [location.pathname])

  return (
    <Suspense fallback={<div>Loading...</div>}>
      {displaySidebar && (
        <Sidebar
          logo={drawerOpen ? `${env.PUBLIC_URL}/static/img/logo.png` : `${env.PUBLIC_URL}/static/img/miniLogo.png`}
          closeDrawer={handleCloseDrawer}
          drawerOpen={drawerOpen}
          withGradient={false}
        />
      )}
      <Content ref={mainPanelRef} drawerOpen={drawerOpen} displaySidebar={displaySidebar}>
        {displayHeader && <Header drawerOpen={drawerOpen} handleDrawerToggle={handleDrawerToggle} displayDrawerButton={displaySidebar} />}
        <Outlet />
        <Footer />
      </Content>
      <ToastContainer theme='colored' />
    </Suspense>
  )
}
